import Component from 'vue-class-component';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import HeaderComponent from '@/components/header/Header.component.vue';
import MenuComponent from '@/components/menu/Menu.component.vue';
import BaseComponent from '@/components/base/BaseComponent.ts';
import { Prop } from 'vue-property-decorator';
import {
  GET_HELP_DESK_DETAILS,
  HELP_DESK_DETAILS,
  MUST_PERFORM_DATA_CLEANSING,
  USER_PERFORM_DATA_CLEANSING,
} from '@/types/lobby.types';
import { SET_USER_DETAILS, USER_DETAILS } from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';
import { HelpDeskDetailsModel } from '@/models/lobby/helpDeskDetails.model';
import IdleModalComponent from '@/components/idle-modal/IdleModal.component.vue';
import { MANAGER_MODE } from '@/types/managerForm.types';
import { FORM_READ_ONLY_MODE } from '@/types/form.types';
import UserDataCleansingModal from '@/components/modals/UserDataCleansing.modal.vue';
import PerformChangePasswordModal from '@/components/modals/PerformChangePassword.modal.vue';
import ChangeAppUserDetailsModal from '@/components/modals/ChangeAppUserDetails.modal.vue';
import { OPEN_CHANGE_APP_USER_DETAILS_MODAL } from '@/types/application-users.types';
import { OPEN_TERMS_AND_PRIVACY_MODAL, SET_OPEN_TERMS_AND_PRIVACY } from '@/types/system.types';

@Component({
  components: {
    HeaderComponent,
    MenuComponent,
    IdleModalComponent,
    UserDataCleansingModal,
    PerformChangePasswordModal,
    ChangeAppUserDetailsModal,
  },
})
export default class DashboardComponent extends BaseComponent {

  @Action(GET_HELP_DESK_DETAILS, StoreNamespace.LOBBY) public getHelpDeskDetails;

  @Mutation(SET_USER_DETAILS, StoreNamespace.AUTHENTICATION) public setUserDetails;
  @Mutation(SET_OPEN_TERMS_AND_PRIVACY , StoreNamespace.SYSTEM) public setOpenTermsAndPrivacyModal;

  @Getter(OPEN_TERMS_AND_PRIVACY_MODAL, StoreNamespace.SYSTEM) public openTermsAndPrivacyModal!: boolean;
  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;
  @Getter(HELP_DESK_DETAILS, StoreNamespace.LOBBY) public helpDeskDetails!: HelpDeskDetailsModel;
  @Getter(MANAGER_MODE, StoreNamespace.MANAGER) public managerMode;
  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode;
  @Getter(MUST_PERFORM_DATA_CLEANSING, StoreNamespace.LOBBY) public mustPerformDataCleansing!: boolean;
  @Getter(USER_PERFORM_DATA_CLEANSING, StoreNamespace.LOBBY) public userPerformDataCleansing!: boolean;
  @Getter(OPEN_CHANGE_APP_USER_DETAILS_MODAL, StoreNamespace.APPLICATION_USER)
  public openChangeAppUserDetailsModal!: boolean;

  @Prop(String) public dialogBodyTitle!: string;

  public bodyTitle: string = '';
  public supportModal = false;
  public currentYear: any = new Date().getFullYear();
  public startYear: any = new Date('January 01, 2020 00:00:00').getFullYear();
  public buildNumber = '';

  public mounted() {
    this.getHelpDeskDetails(this.userDetails.indexNum);
    this.bodyTitle = this.dialogBodyTitle || this.$t('lobby.dialog.dialog_title').toString();
    const userRolesClass = this.userDetails.userRoles.find(e => e.includes('MANAGER') || e.includes('BO'))
      ? 'manager' : 'employee';
    document.getElementsByTagName('body')[0].classList.add(userRolesClass.toLowerCase());
    const buildVersionNumber = process.env.VUE_APP_BUILD_VERSION_NUMBER;
    if (buildVersionNumber && buildVersionNumber !== '_buildNumber_') {
      this.buildNumber = buildVersionNumber;
    }
  }

  public openSupportModal() {
    this.supportModal = true;
  }

  public closeSupportModal() {
    this.supportModal = false;
  }

  public closeTermsDialog(): void {
    this.setOpenTermsAndPrivacyModal(false);
  }

  public openTermsAndPrivacy(): void {
    this.setOpenTermsAndPrivacyModal(true);
  }

  get hideHeaderAndMenu(): boolean {
    return !!this.$route.meta!.hideHeaderAndMenu && !this.mustPerformDataCleansing;
  }

  get showSupport(): boolean {
    return this.$route.meta!.showSupport && ((!this.managerMode) || (this.managerMode && !this.formReadOnlyMode)) &&
      !!(this.helpDeskDetails.technicalPhone || this.helpDeskDetails.professionalPhone);
  }

}

